// Use a button to toggle the display of a div on and off
// Have a button id=toggle-something value="Show something"
// Have a div id="something-toggle" style="display:none"
// Button will toggle display and button text (Show/Hide)

$('*[id^="toggle"]').click(function(event){
    name=this.id;
    section = name.replace(/toggle-/, "");
    state=this.value;
    todo = state.replace(/ .*/, "");
    rest = state.replace(/Show|Hide/, "");
    div_name=section+'-toggle';
    if (todo == "Show") {
      $('#toggle-'+section).val("Hide"+rest);
      document.getElementById(div_name).style.display = "block";
    } else {
      $('#toggle-'+section).val("Show"+ rest);
      document.getElementById(div_name).style.display = "none";
    }
}
)
